import { useContext, useEffect, useRef, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";
import { CaseNavigatorModalContext } from "../../CaseNavigatorModalContext";
import "./case-age-tab.css";

const headers = [
  { full: "< 1 Days", short: "< 1D" },
  { full: "1-2 Days", short: "1-2D" },
  { full: "2-3 Days", short: "2-3D" },
  { full: "1 Week", short: "1W" },
  { full: "1-2 Weeks", short: "1-2W" },
  { full: "1 Month", short: "1M" },
  { full: "1-2 Months", short: "1-2M" },
  { full: "2-3 Months", short: "2-3M" },
  { full: "5-6 Months", short: "5-6M" },
  { full: "1 Year", short: "1Y" },
  { full: "1-2 Years", short: "1-2Y" },
  { full: "2-3 Years", short: "2-3Y" },
  { full: "3-5 Years", short: "3-5Y" },
  { full: "> 5 Years", short: "> 5Y" },
];

const CaseAgeTab = ({ caseTypes, currentFilter, rowCount, onCaseTypeAvailabilityChange }) => {
  const [caseAgeData, setCaseAgeData] = useState([]);
  const { handleShowModal } = useContext(CaseNavigatorModalContext);
  const fetchCaseAgeData = async (currentFilter2) => {
    try {
      const res = await api_without_cancellation.get(
        "/api/navigator/navigator_case_age_data/",
        currentFilter2
          ? {
              params: {
                [currentFilter2.type]: currentFilter2.name || "",
              },
            }
          : {}
      );

      const data = res?.data?.caseage_data ?? [];
      setCaseAgeData(data);
      onCaseTypeAvailabilityChange?.(
        new Set(
          data
            .filter((row) => row.some((item) => item.count > 0))
            .flatMap((row) => {
              const item = row[0];
              const keys = [];
              if (item?.case_type_id !== null && item?.case_type_id !== undefined) {
                keys.push(`id:${item.case_type_id}`);
              }
              if (item?.case_type) {
                keys.push(`name:${item.case_type.trim().toLowerCase()}`);
              }
              return keys;
            })
        )
      );
    } catch (error) {
      console.error("Failed to fetch case age data:", error);
      setCaseAgeData([]);
      onCaseTypeAvailabilityChange?.(new Set());
    }
  };
  // const fetchCaseAgeData = async (currentFilter2) => {
  //   const caseage_data = await api_without_cancellation.get(
  //     "/api/navigator/navigator_case_age_data/",
  //     currentFilter2
  //       ? {
  //           params: {
  //             [currentFilter2.type]: currentFilter2.name || "",
  //           },
  //         }
  //       : {}
  //   );

  //   setCaseAgeData(caseage_data.data.caseage_data);
  // };

  useEffect(() => {
    fetchCaseAgeData(currentFilter);
  }, [currentFilter]);

  const adjustCaseDetailsWidths = () => {
    const leftColumns = document.querySelectorAll(".case-navi-pages-headers");

    let maxLeftWidth = 1000;
    leftColumns.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxLeftWidth = Math.min(maxLeftWidth, width);
    });

    leftColumns.forEach((column) => {
      column.style.width = `${maxLeftWidth}px`;
    });
  };

  useEffect(() => {
    adjustCaseDetailsWidths();
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [caseAgeData]);

  const getSpanText = (spanClass) => {
    switch (spanClass) {
      case "span_1_D":
        return "between 0 Day and 1 Day";
      case "span_2_D":
        return "between 1 Day and 2 Day";
      case "span_3_D":
        return "between 2 Day and 3 Day";
      case "span_1_Wk":
        return "between 3 Day and 1 Week";
      case "span_2_Wks":
        return "between 1 Week and 2 Weeks";
      case "span_1_Mo":
        return "between 2 Week and 1 Month";
      case "span_2_Mos":
        return "between 1 Month and 2 Months";
      case "span_3_Mos":
        return "between 2 Months and 3 Months";
      case "span_6_Mos":
        return "between 3 Months and 6 Months";
      case "span_1_Yr":
        return "between 6 Months and 1 Year";
      case "span_2_Yrs":
        return "between 1 Year and 2 Years";
      case "span_3_Yrs":
        return "between 2 Years and 3 Years";
      case "span_5_Yrs":
        return "between 3 Years and 5 Years";
      case "span_greater_5_Yrs":
        return "more than 5 Years";
      default:
        return "";
    }
  };
  const openModal = (caseType, tabValue, caseTypeId) => () => {
    // const span = getSpanText(tabValue);
    // const typeText = caseType === "" ? "All Case Types" : caseType;
    // const stageOrStatusText = currentFilter === null ? "No Filter Selected" : currentFilter?.name;

    // const headerString = `${typeText} Cases sorted by ${stageOrStatusText} with Case Age ${span}`;
    const span = getSpanText(tabValue);
    const typeText = caseType === "" ? "All Case Types" : caseType;
    const hasFilter = currentFilter && currentFilter.name;

    const headerString = hasFilter
      ? `${typeText} cases filtered by ${currentFilter.name}, with case age ${span}.`
      : `${typeText} cases with case age ${span}.`;

    // const headerString = "Cases sorted by Case Age";

    handleShowModal({
      caseType: caseType,
      // Status: "All Statuses",
      // Stage: "All Stages",
      CurrentFilter: currentFilter,
      tabName: "Case Age",
      tabValue: tabValue,
      headerString: headerString,
      caseTypeId: caseTypeId,
      range: span,
    });
  };
  const tableRef = useRef(null);
  const aggregateRow = caseAgeData.find((row) => !row[0]?.case_type);
  const orderedCaseRows = caseTypes.map(
    (caseType) =>
      caseAgeData.find((row) => row[0]?.case_type === caseType.name) ||
      headers.map(() => ({ count: 0, case_type: caseType.name }))
  );
  const displayRows = aggregateRow ? [aggregateRow, ...orderedCaseRows] : orderedCaseRows;

  const headerRefs = useRef([]);
  const [useShort, setUseShort] = useState(false);

  const checkOverflow = () => {
    // const isOverflowing = headerRefs.current.some(
    //   (el) => el && (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight)
    // );

    setUseShort(window.innerWidth < 1420);
    // setUseShort(isOverflowing);
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  return (
    <>
      <div>
        <table
          ref={tableRef}
          className="table res_tab table-navi-different table-responsive ms-0 equal-column-width-table navigator-standard-table-header"
        >
          <tbody className=" Index-width-webkit-fill-available-display-inline-table">
            <tr className="thead">
              {/* <th className="case-navi-pages-headers">&lt; 1 Days</th>
              <th className="case-navi-pages-headers">1-2 Days</th>
              <th className="case-navi-pages-headers">2-3 Days</th>
              <th className="case-navi-pages-headers">1 Week</th>
              <th className="case-navi-pages-headers">1-2 Weeks</th>
              <th className="case-navi-pages-headers">1 Month</th>
              <th className="case-navi-pages-headers">1-2 Months</th>
              <th className="case-navi-pages-headers">2-3 Months</th>
              <th className="case-navi-pages-headers">5-6 Months</th>
              <th className="case-navi-pages-headers">1 Year</th>
              <th className="case-navi-pages-headers">1-2 Years</th>
              <th className="case-navi-pages-headers">2-3 Years</th>
              <th className="case-navi-pages-headers">3-5 Years</th>
              <th className="case-navi-pages-headers"> &gt; 5 Years</th> */}
              {headers.map((h, i) => (
                <th
                  key={h.full}
                  ref={(el) => (headerRefs.current[i] = el)}
                  className="case-navi-pages-headers"
                >
                  {useShort ? h.short : h.full}
                </th>
              ))}
            </tr>
            {displayRows
              .filter((case_data) => case_data.length > 0)
              .map((case_data, index) => (
                <tr key={index} className="h-25px">
                  {case_data.map((individual_data, idx) =>
                    individual_data.count > 0 ? (
                      <td
                        key={"td-" + idx}
                        className="h-25px cursor-pointer onHoverNewThings text-center"
                        onClick={openModal(
                          individual_data.case_type,
                          individual_data.class_name,
                          individual_data?.case_type_id || ""
                        )}
                      >
                        <p className="fw-bold">{individual_data.count}</p>
                      </td>
                    ) : (
                      <td
                        key={"td-" + idx}
                        className="h-25px cursor-pointer onHoverNewThings text-center"
                      >
                        {/* <p className="text-grey">{individual_data.count}</p> */}
                        {/* <p className="text-grey"></p> */}
                      </td>
                    )
                  )}
                </tr>
              ))}
            {Array.from({ length: Math.max(0, rowCount - displayRows.length + 1) }).map(
              (_, rowIndex) => (
                <tr key={`case-age-empty-${rowIndex}`}>
                  {Array.from({ length: 14 }).map((_, colIndex) => (
                    <td key={colIndex} style={{ height: "25px" }} className="onHoverNewThings" />
                  ))}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CaseAgeTab;
